import { render, staticRenderFns } from "./BattleUserSum.vue?vue&type=template&id=4ce996a7&"
import script from "./BattleUserSum.vue?vue&type=script&lang=ts&"
export * from "./BattleUserSum.vue?vue&type=script&lang=ts&"
import style0 from "./BattleUserSum.vue?vue&type=style&index=0&id=4ce996a7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports